let isPullOrderPending = false;
let pullOrderTimeout = null;
let currentOrderRequest = null;
let sessionStartingToast = null;
let sessionReadyToast = null;
let isVerifone = false;
let isSessionStarted = false;
let accumulatedPrinted = {
  order_ids: new Set(),
  order_product_ids: new Set(),
  product_table_ids: new Set(),
};

let retryCount = 0;
const MAX_RETRIES = 9000000;

$(document).ready(function () {
  isVerifone = $("body").attr("is_verifone") === "1";

  if (window.ReactNativeWebView) {
    $.ajax({
      url: "/api/v1/check-login",
      method: "GET",
      dataType: "json",
    })
      .done(function (data) {
        if (data && data.isLoggedIn) {
          getOrderToPrint().always(() => {
            isPullOrderPending = false;
          });

          passVerifoneDataToWebView({
            action: "verifone",
            data: {
              action: "initialize",
            },
          });
        }
      })
      .fail(function (xhr, status, error) {
        console.error("Error fetching login status:", error);
      });

    function handleOrderPull(printedIds) {
      localStorage.setItem("printedIds", JSON.stringify(printedIds));
      if (printedIds) {
        printedIds.order_ids?.forEach((id) =>
          accumulatedPrinted.order_ids.add(id)
        );
        printedIds.order_product_ids?.forEach((id) =>
          accumulatedPrinted.order_product_ids.add(id)
        );
        printedIds.product_table_ids?.forEach((id) =>
          accumulatedPrinted.product_table_ids.add(id)
        );
      }

      if (isPullOrderPending) {
        cancelOrderPull();
      }

      if (pullOrderTimeout) {
        clearTimeout(pullOrderTimeout);
      }

      isPullOrderPending = true;

      pullOrderTimeout = setTimeout(() => {
        const toSend = {
          order_ids: Array.from(accumulatedPrinted.order_ids),
          order_product_ids: Array.from(accumulatedPrinted.order_product_ids),
          product_table_ids: Array.from(accumulatedPrinted.product_table_ids),
        };

        currentOrderRequest = getOrderToPrint(toSend);
        currentOrderRequest
          .done(() => {
            accumulatedPrinted.order_ids.clear();
            accumulatedPrinted.order_product_ids.clear();
            accumulatedPrinted.product_table_ids.clear();
          })
          .always(() => {
            isPullOrderPending = false;
            pullOrderTimeout = null;
            currentOrderRequest = null;
          });
      }, 7000);
    }

    document.addEventListener("message", function (event) {
      const data = JSON.parse(event.data);

      switch (data.action) {
        case "pull_order":
        case "app_state_active":
          handleOrderPull(data.data);
          break;
        case "web_print_completed":
          const deviceId = data.deviceId;
          const { order_ids: orderIds } = data.data;
          const socketData = {
            type: "web_print_completed",
            deviceId,
            orderIds,
          };
          window.globalSocket.send(JSON.stringify(socketData));
          break;
        case "speech_search":
          appendProductSuggestions(event.data);
          break;
        case "printer_discovery":
          const location_id = $(this).data("location-id");
          savedFoundPrinters(event.data, location_id);
          break;
        case "sync_offline_data":
          synceOfflineData(data.data);
          break;
        case "drawer_status":
          registerDrawerJournal(data.data);
          break;
        case "initialized_sdk":
          passVerifoneDataToWebView({
            action: "verifone",
            data: {
              action: "start_session",
            },
          });
          break;
        case "verifone_state": {
          const { data: result } = data;
          let p = $("body").attr("p");
          let posType = $("body").attr("pos_type");

          if (result) {
            if (result.state === "NOT_LOGGED_IN") {
              if (p === "payment_standby_mode") {
                const verifoneSerialNumber =
                  localStorage.getItem("verifoneSerialNumber") || "";
                window.globalSocket.send(
                  JSON.stringify({
                    type: "verifone",
                    action: "terminal_unavailable",
                    verifoneSerialNumber: verifoneSerialNumber,
                  })
                );
              }

              if (retryCount < MAX_RETRIES) {
                retryCount++;
                sessionStartingToast?.close();
                setTimeout(() => {
                  sessionStartingToast = showToast({
                    message: "Vent litt!",
                    position: "bottom-center",
                    autoHide: false,
                    dismissOnSwipe: true,
                  });
                }, 500);
                passVerifoneDataToWebView({
                  action: "verifone",
                  data: {
                    action: "initialize",
                  },
                });
              } else {
                if (p === "events" && !!posType) {
                  showToast({
                    type: "error",
                    message:
                      "Verifone pålogging mislyktes. Vennligst prøv igjen eller kontakt oss.",
                    autoHide: false,
                    dismissOnSwipe: true,
                    button: {
                      text: "Prøv på nytt",
                      onClick: () => {
                        passVerifoneDataToWebView({
                          action: "verifone",
                          data: {
                            action: "initialize",
                          },
                        });
                        $(".toaster").remove();
                      },
                    },
                  });
                } else if (p === "payment_standby_mode") {
                  window.showConnectionLost();
                }
              }
            } else if (result.state === "CONNECTION_LOST") {
              isSessionStarted = false;
              if (
                $("body").attr("is-verifone-session-started") &&
                $("body").attr("is-verifone-session-started") === "1"
              ) {
                $("body").attr("is-verifone-session-started", "0");
              }

              if ($("#payment-split-modal").length) {
                $(
                  ".payment-split-input[data-payment-method='payment_verifone_terminal']"
                ).prop("disabled", true);
                $(
                  ".order-payment-split[data-payment-method='payment_verifone_terminal']"
                ).prop("disabled", true);
              }

              if (p === "payment_standby_mode") {
                const verifoneSerialNumber =
                  localStorage.getItem("verifoneSerialNumber") || "";
                window.globalSocket.send(
                  JSON.stringify({
                    type: "verifone",
                    action: "terminal_unavailable",
                    verifoneSerialNumber: verifoneSerialNumber,
                  })
                );
              }

              if (retryCount < MAX_RETRIES) {
                retryCount++;
                sessionStartingToast?.close();
                setTimeout(() => {
                  sessionStartingToast = showToast({
                    message: "Vent litt!",
                    position: "bottom-center",
                    autoHide: false,
                    dismissOnSwipe: true,
                  });
                }, 500);
                passVerifoneDataToWebView({
                  action: "verifone",
                  data: {
                    action: "initialize",
                  },
                });
              } else {
                if (p === "payment_standby_mode") {
                  window.showConnectionLost();
                } else {
                  showToast({
                    type: "error",
                    message:
                      "Terminalforbindelsen er brutt. Prøv på nytt eller kontakt oss.",
                    position: "top-right",
                    autoHide: false,
                    dismissOnSwipe: true,
                    button: {
                      text: "Koble til igjen",
                      onClick: () => {
                        passVerifoneDataToWebView({
                          action: "verifone",
                          data: {
                            action: "initialize",
                          },
                        });
                        $(".toaster").remove();
                      },
                    },
                  });
                }
              }
            } else if (result.state === "LOGGED_IN") {
              retryCount = 0;
              if (p === "events" && !!posType) {
                sessionReadyToast = null;
                isSessionStarted = false;
                if (!sessionStartingToast) {
                  sessionStartingToast = showToast({
                    message: "Vent litt!",
                    position: "bottom-center",
                    autoHide: false,
                    dismissOnSwipe: true,
                  });
                }
              }

              passVerifoneDataToWebView({
                action: "verifone",
                data: {
                  action: "start_session",
                },
              });
            } else if (result.state === "SESSION_OPEN") {
              retryCount = 0;
              if (
                !$("body").attr("is-verifone-session-started") ||
                $("body").attr("is-verifone-session-started") === "0"
              ) {
                $("body").attr("is-verifone-session-started", "1");
              }

              if (p === "payment_standby_mode") {
                if (!$("#paymentStatus").hasClass("success")) {
                  window.resetToWaiting();
                }

                const verifoneSerialNumber =
                  localStorage.getItem("verifoneSerialNumber") || "";
                window.globalSocket.send(
                  JSON.stringify({
                    type: "verifone",
                    action: "terminal_available",
                    verifoneSerialNumber: verifoneSerialNumber,
                  })
                );
              }

              if (sessionStartingToast) {
                sessionStartingToast?.close();
                sessionStartingToast = null;
                isSessionStarted = true;

                if ($("#payment-split-modal").length) {
                  $(
                    ".payment-split-input[data-payment-method='payment_verifone_terminal']"
                  ).prop("disabled", false);
                  $(
                    ".order-payment-split[data-payment-method='payment_verifone_terminal']"
                  ).prop("disabled", false);
                }

                if (!sessionReadyToast) {
                  sessionReadyToast = showToast({
                    message: "Klar for transaksjoner",
                    position: "bottom-center",
                    autoHide: true,
                    duration: 3000,
                    dismissOnSwipe: true,
                  });
                }
              }

              $(
                ".quick-order-button[data-payment-method='payment_verifone_terminal']"
              ).prop("disabled", false);
            } else if (result.state === "SESSION_START_FAILED") {
              isSessionStarted = false;

              if (p === "payment_standby_mode") {
                const verifoneSerialNumber =
                  localStorage.getItem("verifoneSerialNumber") || "";
                window.globalSocket.send(
                  JSON.stringify({
                    type: "verifone",
                    action: "terminal_unavailable",
                    verifoneSerialNumber: verifoneSerialNumber,
                  })
                );
              }

              if (
                $("body").attr("is-verifone-session-started") &&
                $("body").attr("is-verifone-session-started") === "1"
              ) {
                $("body").attr("is-verifone-session-started", "0");
              }

              if ($("#payment-split-modal").length) {
                $(
                  ".payment-split-input[data-payment-method='payment_verifone_terminal']"
                ).prop("disabled", true);
                $(
                  ".order-payment-split[data-payment-method='payment_verifone_terminal']"
                ).prop("disabled", true);
              }

              if (retryCount < MAX_RETRIES) {
                retryCount++;
                sessionStartingToast?.close();
                setTimeout(() => {
                  sessionStartingToast = showToast({
                    message: "Vent litt!",
                    position: "bottom-center",
                    autoHide: false,
                    dismissOnSwipe: true,
                  });
                }, 500);
                passVerifoneDataToWebView({
                  action: "verifone",
                  data: {
                    action: "initialize",
                  },
                });
              } else {
                if (p === "payment_standby_mode") {
                  window.showConnectionLost();
                } else {
                  showToast({
                    type: "error",
                    message:
                      "Verifone terminal økt start mislyktes. Vennligst prøv igjen eller kontakt oss.",
                    autoHide: false,
                    dismissOnSwipe: true,
                    button: {
                      text: "Prøv på nytt",
                      onClick: () => {
                        passVerifoneDataToWebView({
                          action: "verifone",
                          data: {
                            action: "initialize",
                          },
                        });
                        $(".toaster").remove();
                      },
                    },
                  });
                }
              }
            }
          }
          break;
        }
        case "payment_completed": {
          const { data: result } = data;
          const verifoneProcessData = JSON.parse(
            localStorage.getItem("verifoneProcessData") || "null"
          );
          const verifoneSerialNumber =
            localStorage.getItem("verifoneSerialNumber") || "";
          if (result.authResult === "AUTHORIZED") {
            const [orderId, orderPaymentSplitId] = String(result.orderId).split(
              "-"
            );
            const paymentData = result.paymentData;
            $.ajax({
              url: "/api/v1/private/order/complete-verifone-order",
              method: "POST",
              dataType: "json",
              data: {
                order_id: orderId,
                card_type: result.cardType || "",
                order_payment_split_id: orderPaymentSplitId || null,
                order_params: paymentData?.orderParams || null,
                terminal_id: verifoneSerialNumber,
              },
            }).done(function (response) {
              if (response.success) {
                if (verifoneProcessData) {
                  window.showPaymentSuccess();

                  const completedInfo = {
                    confirmation_html: "",
                    item_count: 0,
                    total_amount: 0,
                    verifoneSerialNumber,
                  };

                  if (response.order_html && response.order_html !== "") {
                    completedInfo.order_html = response.order_html;
                  }

                  if (response.item_count && response.total_amount) {
                    completedInfo.item_count = response.item_count;
                    completedInfo.total_amount = response.total_amount;
                  }

                  let orderProducts = [];
                  if (
                    response.order_products &&
                    Array.isArray(response.order_products)
                  ) {
                    orderProducts = response.order_products;
                  }

                  window.globalSocket.send(
                    JSON.stringify({
                      type: "verifone",
                      action: "completed_payment",
                      deviceId: verifoneProcessData.senderDeviceId,
                      senderDeviceId: localStorage.getItem("deviceID"),
                      completedInfo,
                      orderProducts,
                    })
                  );
                  setTimeout(() => {
                    localStorage.removeItem("verifoneProcessData");
                  }, 1500);
                } else {
                  if ($("#paymentProcessModal").hasClass("show")) {
                    $("#paymentProcessModal").modal("hide");
                  }

                  if (orderPaymentSplitId && response.success) {
                    if (!response.item_count && !response.total_amount) {
                      passVerifoneDataToWebView({
                        action: "verifone",
                        data: {
                          action: "start_session",
                        },
                      });
                    }
                    const splitInput = $(
                      `.payment-split-input[data-payment-method='payment_verifone_terminal']`
                    );
                    const splitButton = $(
                      `.order-payment-split[data-payment-method='payment_verifone_terminal']`
                    );
                    splitButton.find("div.loader").remove();
                    splitButton.attr("disabled", false);
                    splitButton.text(splitButton.attr("data-original-text"));
                    const paidAmount = parseFloat(splitInput.val());
                    splitInput.val("");

                    let totalAmount = parseFloat(
                      splitInput.attr("data-max-allowed")
                    );
                    const remainingAmout = parseFloat(
                      $("#total-amount").attr("data-total-amount")
                    );
                    const totalPaid = totalAmount - remainingAmout + paidAmount;
                    if (totalPaid > 0) {
                      const remainingValue =
                        (totalAmount * 100 - totalPaid * 100) / 100;
                      $("#total-amount").text(
                        `Gjenværende totalt: ${formattedPriceToShow(
                          remainingValue
                        )}`
                      );
                      $("#total-amount").attr(
                        "data-total-amount",
                        remainingValue
                      );

                      $("#payment-split-input").attr(
                        "data-max-allowed",
                        remainingValue
                      );
                    }
                  }

                  if (response.order_html && response.order_html !== "") {
                    $(".confirmation-toast").remove();
                    $("#content").append(
                      '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
                        (window.innerWidth >= 500 ? " right: 0;" : "") +
                        ' width: 480px; display: none;">' +
                        '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="false" data-delay="100000">' +
                        '  <div class="toast-header">' +
                        '    <strong class="mr-auto">Ordre registrert</strong>' +
                        "    <small></small>" +
                        '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
                        '      <span aria-hidden="true">&times;</span>' +
                        "    </button>" +
                        "  </div>" +
                        '  <div class="toast-body">' +
                        response.order_html +
                        "  </div>" +
                        "</div>" +
                        "</div>"
                    );
                  }

                  if (response.item_count && response.total_amount) {
                    sessionReadyToast = null;
                    isSessionStarted = false;

                    if ($("#payment-split-modal").length) {
                      $("#payment-split-modal").modal("hide");
                    }

                    showPreviousSaleBar(
                      response.item_count,
                      response.total_amount
                    );

                    if (
                      response.orderProducts &&
                      response.orderProducts.length > 0
                    ) {
                      const orderProducts = response.orderProducts;
                      const productsWithCount = [];

                      orderProducts.forEach((product) => {
                        const productDetail = `(${product.quantity})${product.name}`;
                        productsWithCount.push(productDetail);
                      });

                      localStorage.setItem(
                        "lastOrderProducts",
                        JSON.stringify(productsWithCount)
                      );
                      localStorage.setItem(
                        "lastOrderTotal",
                        response.total_amount
                      );
                    }

                    emptyAllCart();
                    closePanel();
                  }
                }

                passVerifoneDataToWebView({
                  action: "verifone",
                  data: {
                    action: "start_session",
                  },
                });
              }
            });
          } else if (result.authResult === "DECLINED") {
            if (verifoneProcessData) {
              window.showPaymentFailed();
              window.globalSocket.send(
                JSON.stringify({
                  type: "verifone",
                  action: "declined_payment",
                  deviceId: verifoneProcessData.senderDeviceId,
                  senderDeviceId: localStorage.getItem("deviceID"),
                  verifoneSerialNumber,
                })
              );
              setTimeout(() => {
                passVerifoneDataToWebView({
                  action: "verifone",
                  data: {
                    action: "start_session",
                  },
                });
                localStorage.removeItem("verifoneProcessData");
              }, 1500);
            } else {
              $("#paymentProcessSpinner").addClass("d-none");
              $("#paymentProcessError").removeClass("d-none");
              const declinedMessage =
                $("#paymentStatus").data("declined-message") ||
                "Payment Declined";
              $("#paymentStatus").text(declinedMessage);
              $("#retryPaymentButton").removeClass("d-none");

              sessionReadyToast = null;
              isSessionStarted = false;
              passVerifoneDataToWebView({
                action: "verifone",
                data: {
                  action: "start_session",
                },
              });

              const splitButton = $(
                `.order-payment-split[data-payment-method='payment_verifone_terminal']`
              );
              $("#payment-split-input").attr("disabled", false);
              splitButton.find("div.loader").remove();
              splitButton.attr("disabled", false);
              splitButton.text(splitButton.attr("data-original-text"));

              paymentData = result.paymentData;
            }
          } else if (result.authResult === "USER_CANCELLED") {
            if (verifoneProcessData) {
              window.showPaymentFailed();
              window.globalSocket.send(
                JSON.stringify({
                  type: "verifone",
                  action: "user_cancelled_payment",
                  deviceId: verifoneProcessData.senderDeviceId,
                  senderDeviceId: localStorage.getItem("deviceID"),
                  verifoneSerialNumber,
                })
              );
              setTimeout(() => {
                passVerifoneDataToWebView({
                  action: "verifone",
                  data: {
                    action: "start_session",
                  },
                });
                localStorage.removeItem("verifoneProcessData");
              }, 1500);
            } else {
              $("#paymentProcessSpinner").addClass("d-none");
              $("#paymentProcessError").removeClass("d-none");
              const userCancelledMessage =
                $("#paymentStatus").data("user-cancelled-message") ||
                "Payment Cancelled by User";
              $("#paymentStatus").text(userCancelledMessage);
              $("#retryPaymentButton").removeClass("d-none");

              sessionReadyToast = null;
              isSessionStarted = false;
              passVerifoneDataToWebView({
                action: "verifone",
                data: {
                  action: "start_session",
                },
              });

              const splitButton = $(
                `.order-payment-split[data-payment-method='payment_verifone_terminal']`
              );
              $("#payment-split-input").attr("disabled", false);
              splitButton.find("div.loader").remove();
              splitButton.attr("disabled", false);
              splitButton.text(splitButton.attr("data-original-text"));

              paymentData = result.paymentData;
            }
          } else {
            if (verifoneProcessData) {
              window.showPaymentFailed();
              window.globalSocket.send(
                JSON.stringify({
                  type: "verifone",
                  action: "de",
                  deviceId: verifoneProcessData.senderDeviceId,
                  senderDeviceId: localStorage.getItem("deviceID"),
                  verifoneSerialNumber,
                })
              );
              setTimeout(() => {
                passVerifoneDataToWebView({
                  action: "verifone",
                  data: {
                    action: "start_session",
                  },
                });
                localStorage.removeItem("verifoneProcessData");
              }, 1500);
            } else {
              $("#paymentProcessSpinner").addClass("d-none");
              $("#paymentProcessError").removeClass("d-none");
              const userCancelledMessage =
                $("#paymentStatus").data("user-cancelled-message") ||
                "Payment Cancelled by User";
              $("#paymentStatus").text(userCancelledMessage);
              $("#retryPaymentButton").removeClass("d-none");

              sessionReadyToast = null;
              isSessionStarted = false;
              passVerifoneDataToWebView({
                action: "verifone",
                data: {
                  action: "start_session",
                },
              });

              const splitButton = $(
                `.order-payment-split[data-payment-method='payment_verifone_terminal']`
              );
              $("#payment-split-input").attr("disabled", false);
              splitButton.find("div.loader").remove();
              splitButton.attr("disabled", false);
              splitButton.text(splitButton.attr("data-original-text"));

              paymentData = result.paymentData;
            }
          }
          isTerminalBusy = false;
          break;
        }
        case "device_info": {
          const { data: result } = data;
          if (result?.isVerifone && result) {
            $(".device-information-section").removeClass("d-none");
            var deviceData = result;
            const verifoneSerialNumber =
              deviceData.serialNumber?.replace(/-/g, "") || "";

            $("#appVersion").text(deviceData.applicationVersion || "N/A");
            $("#paymentAppName").text(deviceData.paymentAppName || "N/A");
            $("#paymentAppVersion").text(deviceData.paymentAppVersion || "N/A");
            $("#serialNumber").text(deviceData.serialNumber || "N/A");

            if ($(".navbar-brand").length) {
              $(".navbar-brand").attr(
                "data-terminal-serial-number",
                deviceData.serialNumber || ""
              );
            }

            localStorage.setItem("verifoneSerialNumber", verifoneSerialNumber);
          }

          if (result?.applicationVersion) {
            if (
              $("#footer-android-build-version").length &&
              $("#footer-android-build-version").hasClass("d-none")
            ) {
              $("#footer-android-build-version")
                .text(
                  "Application version: " + (result.applicationVersion || "N/A")
                )
                .removeClass("d-none");
            }
          }
        }
      }
    });

    window.addEventListener("message", function (event) {
      const data = JSON.parse(event.data);
      switch (data.action) {
        case "pull_order":
        case "app_state_active":
          handleOrderPull(data.data);
          break;
        case "web_print_completed":
          const deviceId = data.deviceId;
          const { order_ids: orderIds } = data.data;
          const socketData = {
            type: "web_print_completed",
            deviceId,
            orderIds,
          };
          window.globalSocket.send(JSON.stringify(socketData));
          break;
        case "speech_search":
          appendProductSuggestions(event.data);
          break;
        case "printer_discovery":
          const location_id = $(this).data("location-id");
          savedFoundPrinters(event.data, location_id);
          break;
        case "sync_offline_data":
          synceOfflineData(data.data);
          break;
        case "drawer_status":
          registerDrawerJournal(data.data);
          break;
        case "initialized_sdk":
          break;
        case "verifone_state": {
          const { data: result } = data;
          if (result) {
            if (result.state === "NOT_LOGGED_IN") {
              let p = $("body").attr("p");
              let posType = $("body").attr("pos_type");

              if (p === "events" && !!posType) {
                showToast({
                  type: "error",
                  message:
                    "Verifone pålogging mislyktes. Vennligst prøv igjen eller kontakt oss.",
                  autoHide: false,
                  dismissOnSwipe: true,
                  button: {
                    text: "Prøv på nytt",
                    onClick: () => {
                      passVerifoneDataToWebView({
                        action: "verifone",
                        data: {
                          action: "initialize",
                        },
                      });
                      $(".toaster").remove();
                    },
                  },
                });
              }
            } else if (result.state === "CONNECTION_LOST") {
              showToast({
                type: "error",
                message:
                  "Terminalforbindelsen er brutt. Prøv på nytt eller kontakt oss.",
                autoHide: false,
                dismissOnSwipe: true,
                button: {
                  text: "Koble til igjen",
                  onClick: () => {
                    passVerifoneDataToWebView({
                      action: "verifone",
                      data: {
                        action: "initialize",
                      },
                    });
                    $(".toaster").remove();
                  },
                },
              });
            } else if (result.state === "LOGGED_IN") {
              let p = $("body").attr("p");
              let posType = $("body").attr("pos_type");

              if (p === "events" && !!posType) {
                sessionReadyToast = null;
                if (!sessionStartingToast) {
                  sessionStartingToast = showToast({
                    message: "Vent litt!",
                    position: "bottom-center",
                    autoHide: false,
                    dismissOnSwipe: true,
                  });
                }

                passVerifoneDataToWebView({
                  action: "verifone",
                  data: {
                    action: "start_session",
                  },
                });
              }
            } else if (result.state === "SESSION_OPEN") {
              if (sessionStartingToast) {
                sessionStartingToast?.close();
                sessionStartingToast = null;
                if (!sessionReadyToast) {
                  sessionReadyToast = showToast({
                    message: "Klar for transaksjoner",
                    position: "bottom-center",
                    autoHide: true,
                    duration: 3000,
                    dismissOnSwipe: true,
                  });
                }
              }

              $(
                ".quick-order-button[data-payment-method='payment_verifone_terminal']"
              ).prop("disabled", false);
            } else if (result.state === "SESSION_START_FAILED") {
              showToast({
                type: "error",
                message:
                  "Verifone terminal økt start mislyktes. Vennligst prøv igjen eller kontakt oss.",
                autoHide: false,
                dismissOnSwipe: true,
                button: {
                  text: "Prøv på nytt",
                  onClick: () => {
                    passVerifoneDataToWebView({
                      action: "verifone",
                      data: {
                        action: "initialize",
                      },
                    });
                    $(".toaster").remove();
                  },
                },
              });
            }
          }
          break;
        }
        case "payment_completed": {
          const { data: result } = data;
          if (result.authResult === "AUTHORIZED") {
            $.ajax({
              url: "/api/v1/private/order/complete-verifone-order",
              method: "POST",
              dataType: "json",
              data: {
                order_id: result.orderId,
                card_type: result.cardType || "",
              },
            }).done(function (response) {
              if (response.success) {
                if ($("#paymentProcessModal").hasClass("show")) {
                  $("#paymentProcessModal").modal("hide");
                }

                if (response.item_count && response.total_amount) {
                  sessionReadyToast = null;
                  showPreviousSaleBar(
                    response.item_count,
                    response.total_amount
                  );
                  passVerifoneDataToWebView({
                    action: "verifone",
                    data: {
                      action: "start_session",
                    },
                  });
                }
                emptyAllCart();
                closePanel();
              }
            });
          } else if (result.authResult === "DECLINED") {
            $("#paymentProcessSpinner").addClass("d-none");
            $("#paymentProcessError").removeClass("d-none");
            const declinedMessage =
              $("#paymentStatus").data("declined-message") ||
              "Payment Declined";
            $("#paymentStatus").text(declinedMessage);
            $("#retryPaymentButton").removeClass("d-none");

            sessionReadyToast = null;

            passVerifoneDataToWebView({
              action: "verifone",
              data: {
                action: "start_session",
              },
            });
            paymentData = result.paymentData;
          } else if (result.authResult === "USER_CANCELLED") {
            $("#paymentProcessSpinner").addClass("d-none");
            $("#paymentProcessError").removeClass("d-none");
            const userCancelledMessage =
              $("#paymentStatus").data("user-cancelled-message") ||
              "Payment Cancelled by User";
            $("#paymentStatus").text(userCancelledMessage);
            $("#retryPaymentButton").removeClass("d-none");

            sessionReadyToast = null;

            passVerifoneDataToWebView({
              action: "verifone",
              data: {
                action: "start_session",
              },
            });
            paymentData = result.paymentData;
          }
          break;
        }
        case "device_info": {
          const { data: result } = data;
          if (result?.applicationVersion) {
            $(".device-information-section").removeClass("d-none");

            if (
              $("#footer-android-build-version").length &&
              $("#footer-android-build-version").hasClass("d-none")
            ) {
              $("#footer-android-build-version")
                .text(
                  "Application version: " + (result.applicationVersion || "N/A")
                )
                .removeClass("d-none");
            }

            localStorage.setItem("verifoneSerialNumber", verifoneSerialNumber);
          }
        }
      }
    });
  }
});

function cancelOrderPull() {
  if (currentOrderRequest) {
    currentOrderRequest.abort();
    currentOrderRequest = null;
  }

  if (pullOrderTimeout) {
    clearTimeout(pullOrderTimeout);
    pullOrderTimeout = null;
  }

  isPullOrderPending = false;
}
